





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositOverdraftInterestSettingsEdit from '@/components/Products/Forms/Deposit/DepositOverdraftInterestSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositOverdraftInterestSettingsEditDialog', components: { DepositOverdraftInterestSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
            await ProductDetailsModule.getRateSources();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositOverdraftInterestSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
